<!-- <div class="home-page-wrapper" >
	
	<span style="align-content: center; font-size: 30px;">
		Home Page
	</span>
</div> -->

<app-cvx-header
    [pTitle]="APP_CONFIG.appTitle"
    [pFullName]="profileName()"
	[pSRCImageProfileUser]="imagenUrl()"
	[pRoleName]="roleName()"
/>

<app-cvx-navbar />
<!-- <app-cvx-navbar [pMenuItems]="navbarMenuItems()"/> -->

<app-cvx-main />
